// extracted by mini-css-extract-plugin
export default {"root":"styles_root__FVMKe","label":"styles_label__fH6Hg"};